export default {"src":"/_next/static/media/snapchat.1a29716f.svg","height":172,"width":191,"blurWidth":0,"blurHeight":0};